module.exports = __webpack_public_path__ + "img/epr-price@2x.a2e7f4d9.webp";